<template>
  <div class="org">
    <img src="../../assets/org.png"/>
  </div>
</template>

<script>

export default {
  name: 'org',
  components: {
  }
}
</script>